module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-6-34e39e5a771076f07f0c2543758c0801.png";